import React from "react";
import { Route, Switch } from "react-router-dom";

import InsuredUsers from "./containers/insuredUsers";

const routes = () => {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/benefit/insured-list" component={InsuredUsers} />
			</Switch>
		</React.Fragment>
	);
};

export default routes;
